// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  padding: 2rem;
  text-align: center;
  background-color: var(--background);
}
.main-container h1 {
  font-size: 250%;
  text-align: center;
  color: var(--text-color);
}
.main-container h2 {
  margin-top: 1rem;
  font-weight: bold;
  text-align: center;
  color: var(--text-color);
}
.main-container mat-divider {
  margin: 2rem 0;
}
.main-container mat-card {
  margin: 1rem 0;
}
.main-container mat-card ::ng-deep .mat-card-header-text {
  width: 100%;
  text-align: center;
}
.main-container mat-card mat-card-content {
  text-align: justify;
}
.main-container mat-card img {
  object-fit: cover;
  height: 70%;
}

.fxFlex-35 {
  flex: 1 1 35%;
  max-width: 35%;
  box-sizing: border-box;
}

@media only screen and (min-width: 1280px) {
  .fxFlex-23-30md-45sm {
    flex: 1 1 23%;
    max-width: 23%;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1279px) {
  .fxFlex-23-30md-45sm {
    flex: 1 1 30%;
    max-width: 30%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 959px) {
  .fxFlex-23-30md-45sm {
    flex: 1 1 45%;
    max-width: 45%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/organisers/organisers.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;AACF;AACE;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;AACJ;AAEE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,cAAA;AAFJ;AAII;EACE,WAAA;EACA,kBAAA;AAFN;AAKI;EACE,mBAAA;AAHN;AAMI;EACE,iBAAA;EACA,WAAA;AAJN;;AAWA;EAEE,aAAA;EACA,cAAA;EACA,sBAAA;AATF;;AAcA;EAEE;IAGE,aAAA;IACA,cAAA;IACA,sBAAA;EAdF;AACF;AAoBA;EAEE;IAGE,aAAA;IACA,cAAA;IACA,sBAAA;EArBF;AACF;AA2BA;EAEE;IAGE,aAAA;IACA,cAAA;IACA,sBAAA;EA5BF;AACF","sourcesContent":[".main-container {\r\n  padding: 2rem;\r\n  text-align: center;\r\n  background-color: var(--background);\r\n\r\n  h1 {\r\n    font-size: 250%;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  h2 {\r\n    margin-top: 1rem;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    color: var(--text-color);\r\n  }\r\n\r\n  mat-divider {\r\n    margin: 2rem 0;\r\n  }\r\n\r\n  mat-card {\r\n    margin: 1rem 0;\r\n\r\n    ::ng-deep .mat-card-header-text {\r\n      width: 100%;\r\n      text-align: center;\r\n    }\r\n\r\n    mat-card-content {\r\n      text-align: justify;\r\n    }\r\n\r\n    img {\r\n      object-fit: cover;\r\n      height: 70%;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Media query za site uredi (xs, sm, md, lg, xl uredi)\r\n.fxFlex-35 {\r\n\r\n  flex: 1 1 35%;\r\n  max-width: 35%;\r\n  box-sizing: border-box;\r\n\r\n}\r\n\r\n// Media query za site uredi pogolemi od 1280px (lg i xl uredi)\r\n@media only screen and (min-width:1280px) {\r\n\r\n  .fxFlex-23-30md-45sm {\r\n\r\n\r\n    flex: 1 1 23%;\r\n    max-width: 23%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n\r\n}\r\n\r\n// Media query za site uredi pogolemi od 960px i pomali od 1280px (md uredi)\r\n@media only screen and (min-width:960px) and (max-width:1279px) {\r\n\r\n  .fxFlex-23-30md-45sm {\r\n\r\n\r\n    flex: 1 1 30%;\r\n    max-width: 30%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n\r\n}\r\n\r\n// Media query za site uredi pomali od 960px (xs i sm uredi)\r\n@media only screen and (max-width:959px) {\r\n\r\n  .fxFlex-23-30md-45sm {\r\n\r\n\r\n    flex: 1 1 45%;\r\n    max-width: 45%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
